module.exports = {
	"articleTitle1": "Prickly Pear offers unique flavors",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Prickly Pear",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/04best-ann-arbor-2015-full-list16",
	"articleSnippet1": "Nov 21, 2002 ... \"What the hell is a Prickly Pear?\" my roommate Mike yelled at us as we were \nleaving. I guess he was mad because we didn't invite him to go.",
	"articleSnippet2": "Apr 15, 2015 ... ... Korean Food: Seoul Garden; Thai Food: Marnee Thai; Mediterranean Food: La \nMarsa; Mexican Food: Prickly Pear; Dessert/Sweets: Cupcake ...",
	"foodRecommendations": [],
	"articleTitle2": "Best of Ann Arbor 2015 - Full List",
	"address": "328 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278618,
		"lng": -83.748945
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pricklypear.json
// module id = 953
// module chunks = 0